import { useQuery } from '@tanstack/react-query'
import type {
  ActivityStatsResponseDto,
  FunnelStatsResponseDto,
  LlmStatsResponseDto,
  OverviewStatsResponseDto,
} from '@lunary/api-client'
import { api } from '../../shared/api/client'

export const PERIODS = [7, 30, 90] as const
export type PeriodDays = (typeof PERIODS)[number]

function range(days: PeriodDays): { from: string; to: string } {
  const now = Date.now() + 3 * 3_600_000
  const to = new Date(now).toISOString().slice(0, 10)
  const from = new Date(now - (days - 1) * 86_400_000).toISOString().slice(0, 10)
  return { from, to }
}

function useStats<T>(path: string, days: PeriodDays, enabled: boolean) {
  return useQuery({
    queryKey: ['admin-stats', path, days],
    queryFn: () => api.get<T>(`/admin/stats/${path}`, { query: range(days) }),
    enabled,
    staleTime: 60_000,
  })
}

export const useOverviewStats = (days: PeriodDays, enabled: boolean) =>
  useStats<OverviewStatsResponseDto>('overview', days, enabled)
export const useActivityStats = (days: PeriodDays, enabled: boolean) =>
  useStats<ActivityStatsResponseDto>('activity', days, enabled)
export const useFunnelStats = (days: PeriodDays, enabled: boolean) =>
  useStats<FunnelStatsResponseDto>('funnel', days, enabled)
export const useLlmStats = (days: PeriodDays, enabled: boolean) => useStats<LlmStatsResponseDto>('llm', days, enabled)
